module.exports = __webpack_public_path__ + "static/media/MCT-Web-Slider_1_1020px.475a363b.jpg";